import React, { useEffect, useState } from "react";
import PageTitle from "./PageTitle";
import Stats from "./Stats";
import Table from "./Table";
import axios from "axios";
import { useParams } from "react-router-dom";
import API_KEY from "api";
import {Skeleton} from 'antd'
export default function BuyerActivityDetails() {
  const [data, setData] = useState(null);
  const params = useParams();
  const [collectionDetails, setCollectionDetails] = useState(null);
const [loading, setLoading] = useState(false);
// pollling for data
  useEffect(() => {
   
      const timer = setInterval(fetchData, 5000);
      return () => clearInterval(timer);
  
  }, []);

  const fetchData =  () => {
    const user = localStorage.getItem('user');
    const token = JSON.parse(user).access_token
    axios
    .get(
      `${process.env.REACT_APP_API_SERVICE}analytics/details/?sessionIdentifier=${params?.id}&&token=${token}`
    )
    .then((res) => {
      setData(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
  }

  // api call
  useEffect(() => {
    setLoading(true);
    const user = localStorage.getItem('user');
    const token = JSON.parse(user).access_token
    axios
      .get(
        `${process.env.REACT_APP_API_SERVICE}analytics/details/?sessionIdentifier=${params?.id}&&token=${token}`
      )
      .then((res) => {
        setLoading(false);
        setData(res.data);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }, [params]);

  // get collection data using collection link and set it to state and local storage
  useEffect(() => {
    API_KEY.URL.get(API_KEY.path.collections, {
      params: {
        "filter[collection_link][_eq]": params?.id,
        fields: "*",
      },
    }).then((res) => {
      
      setCollectionDetails(res?.data?.data?.[0]);
     
    });
  }, [params]);

  return (
    <div>
     {
        loading ? <Skeleton active/> :  <PageTitle collectionDetails={collectionDetails}  />
     }
     {
        loading ? <Skeleton active/> :  <Stats data={data} />
     }
     {
        loading ? <Skeleton active/> :  <Table data={data} />
     }
     
    </div>
  );
}
